function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useFormikContext } from 'formik';
import React from 'react';
import { Label } from 'reactstrap';
import { t } from "../../../services/translator";
export default (function (_ref) {
  var name = _ref.name,
      children = _ref.children,
      text = _ref.text,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["name", "children", "text", "size"]);

  var display = text || children;
  var context = useFormikContext();
  var isRequired = props.required !== undefined ? props.required : name !== undefined && context.mapping !== undefined && context.mapping.isRequired(name);

  if (name === display && context.resource) {
    display = context.resource.getTranslationKey(name.replace(/[[']['\]]/g, '').replace(/\[.*]/g, ''));
  }

  return /*#__PURE__*/React.createElement(Label, _extends({
    size: size
  }, props), typeof display === 'string' ? t(display) : display, isRequired && ' *');
});